export default __webpack_public_path__ + "static/ingegneria-software-sostenibile-strategie-green-cto-team-it-34bf9cbdb5d667056db1ae0e5d7b168c.jpg";